import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';

import FAIcon from './FAIcon.jsx';

const ViewSwitcher = ({ activeView, changeView }) => {
  function getButtonStyle(viewName) {
    return (viewName === activeView) ? 'primary' : 'default';
  }

  return (
    <div className="pull-right">
      <ButtonToolbar>
        <Button bsStyle={getButtonStyle('CALENDAR')} onClick={() => changeView('CALENDAR')}>
          <FAIcon icon="calendar" /> Kalenteri
        </Button>
        <Button bsStyle={getButtonStyle('MAP')} onClick={() => changeView('MAP')}>
          <FAIcon icon="globe" /> Kartta
        </Button>
      </ButtonToolbar>
    </div>
  );
};

ViewSwitcher.propTypes = {
  activeView: PropTypes.string.isRequired,
  changeView: PropTypes.func.isRequired
};

export default ViewSwitcher;



// WEBPACK FOOTER //
// ./src/components/ViewSwitcher.jsx